const toPixels = (value) => `${value}px`;

// Draggable settings
export const DRAGGABLE_DROP_IS_STICKY = false;

// Throtthle
export const PLANNING_DRAG_THROTTHLE = 100;
export const CURRENT_WEEK_RESIZE_OBSERVER_THROTTHLE = 500;
export const PLANNING_SCROLL_THROTTHLE = 500;

// Grid
export const COLUMN_WIDTH = 65;
export const COLUMN_WIDTH_IN_PIXELS = toPixels(COLUMN_WIDTH);
export const DEFAULT_EMPTY_ROWS = 1;
export const GRID_GROUP_COLUMN_WIDTH = 120;
export const GRID_GROUP_COLUMN_WIDTH_IN_PIXELS = toPixels(
  GRID_GROUP_COLUMN_WIDTH,
);
export const GRID_OPEN_FIRST_X_GROUPS = 3;

// Periods
export const MAX_PERIODS = 16;
export const DEFAULT_PERIOD_LENGTH = 18;
export const DEFAULT_PERIOD_NAME = "Naamloze periode";
export const DEFAULT_PERIOD_OBJECT = {
  id: null,
  start_week: null,
  start_year: null,
  end_week: null,
  end_year: null,
  school_year: null,
  name: "",
  type: "period",
  duration: DEFAULT_PERIOD_LENGTH,
  temporary: false,
  meta: {
    can_update: true,
    can_delete: true,
  },
};

// Planable model
export const DEFAULT_PLANABLE_OBJECT = {
  start_week: null,
  start_year: null,
  end_week: null,
  end_year: null,
  school_year: "2024/2025",
  planningMeta: {},
};

// Clusters
export const DEFAULT_CLUSTER_LENGTH = 4;
export const EMPTY_CLUSTER_NAME = "Naamloos cluster";
export const DEFAULT_CLUSTER_OBJECT = {
  ...DEFAULT_PLANABLE_OBJECT,
  id: null,
  school_id: null,
  groupId: null,
  lesson_class: null,
  name: "",
  description: "",
  type: "cluster",
  duration: DEFAULT_CLUSTER_LENGTH,
  temporary: true,
  user: {},
  shortage: null,
  subjects: [],
  education_year_levels: [],
  editable: false,
  library_cluster_id: null,
  library_learning_objectives: [],
  library_learning_objective_ids: [],
  learning_objectives: [],
  subject_name: null,
  subject_shortage: null,
  attachments: [],
  videos: [],
  links: [],
  meta: {
    can_update: true,
    can_delete: true,
  },
};

// Planning meta
export const DEFAULT_PLANNING_META = {
  isResizing: false,
  startX: 0,
  handleTarget: null,
  handleX: 0,
  throttledResize: null,
  resizingPart: null,
  manager: null,
  canDrag: false,
  isDraggable: false,
  weekIndexes: [],
  initialDragState: {},
  rowIndex: null,
  groupId: null,
  groupIndex: null,
};

export const DEFAULT_SLO_KEYS = {
  slo_core_purpose_uuids: [],
  slo_core_purposes: [],
  slo_target_uuids: [],
  slo_targets: [],
};

export const DEFAULT_CLUSTER_LEARNING_OBJECTIVE = {
  id: null,
  cluster_id: null,
  library_learning_objective_id: null,
  education_year_levels: [],
  order: 0,
  name: "",
  teacher_hints: "",
  topics: [],
  success_criterias: [],
  attachments: [],
  videos: [],
  links: [],
  subjects: [],
  connected_library_clusters: [],
  planned: false,
  track_score: true,
  is_editing: false,
  editable: false,
  ...DEFAULT_SLO_KEYS,
  trashed: false,
  type: null,
  meta: {
    can_update: true,
    can_delete: true,
  },
};

export const DEFAULT_SUCCESS_CRITERIA = {
  id: null,
  library_learning_objective_id: null,
  order: 0,
  name: "",
  teacher_hints: "",
  attachments: [],
  links: [],
  videos: [],
  is_editing: false,
  is_temporary: true,
  ...DEFAULT_SLO_KEYS,
  meta: {
    can_update: true,
    can_delete: true,
  },
};

// Grid groups
export const DEFAULT_GRID_GROUP = {
  id: null,
  name: "",
  isDragging: false,
  meta: {
    isVisibile: false,
  },
};

export default {
  PLANNING_DRAG_THROTTHLE,
  COLUMN_WIDTH,
  COLUMN_WIDTH_IN_PIXELS,
  MAX_PERIODS,
  DEFAULT_PERIOD_LENGTH,
  DEFAULT_PERIOD_OBJECT,
  DEFAULT_PLANNING_META,
  DEFAULT_CLUSTER_LENGTH,
  DEFAULT_CLUSTER_OBJECT,
  DEFAULT_GRID_GROUP,
  DEFAULT_CLUSTER_LEARNING_OBJECTIVE,
};
